import graphql__5f44e6fe74cc52659472 from "./__generated__/AnswerPresentationTextZone_answer.graphql.js";import { graphql, useFragment } from "react-relay";

const AnswerPresentationTextZone = function (props) {
  const { formField } = useFragment(AnswerPresentationTextZone_answer, props.answer);
  const { content } = formField;

  return (
    <div
      className="form-presentation-text-zone text-default form-help-block"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

const AnswerPresentationTextZone_answer = graphql__5f44e6fe74cc52659472;

export default AnswerPresentationTextZone;
